import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDatas } from '../../../../services/axiosInstanceService';
import { adPlotsApiToStoreParser } from '../../adParser';

interface IFetchAdPlotLocationsThunkProps {
  isLand: boolean;
  area: number;
  minLandArea: number | null;
  maxLandArea: number | null;
  inseeCode: string | null;
}
const fetchAdPlotLocationsThunk = createAsyncThunk(
  'ad/fetchAdPlotLocationsThunk',
  async (params: IFetchAdPlotLocationsThunkProps) => {
    try {
      const { isLand, area, minLandArea, maxLandArea, inseeCode } = params;
      if (!inseeCode) throw new Error('No insee code found');

      const requestParams: Record<string, string | number | boolean> = {
        area,
        is_land: isLand,
      };

      //BFF Contract: minLandArea and maxLandArea must be used together or neither.
      if (minLandArea !== null && maxLandArea !== null) {
        requestParams.min_land_area = minLandArea;
        requestParams.max_land_area = maxLandArea;
      }

      const response = await fetchDatas(
        `/parcels/${inseeCode}/result_by_land_area_explicit`,
        requestParams,
      );

      const parsed = adPlotsApiToStoreParser(response['hydra:member']);

      return parsed;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export default fetchAdPlotLocationsThunk;
